<ng-container *ngIf="!noGroups">
  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item" *lmsProfileGuard="'groups.create'" tools-actions>
      <gl-context-menu small *ngIf="coursesService.hasMarsEnabled(); else createRegularGroup" gap="0">
        <gl-button
          slot="target"
          color-primary
          dropdown
          [text]="'groups.add' | translate"
          title="{{ 'groups.create' | translate }}"
        ></gl-button>
        <gl-menu-item
          [routerLink]="['/groups/new']"
          [queryParams]="{ clientId: client.id }"
          text="{{ 'groups.createGroup' | translate }}"
          class="cursor-pointer"
        ></gl-menu-item>
        <gl-menu-item
          [routerLink]="['/groups/mars/new']"
          [queryParams]="{ clientId: client.id }"
          text="{{ 'groups.createMarsGroup' | translate }}"
          class="cursor-pointer"
        ></gl-menu-item>
      </gl-context-menu>

      <ng-template #createRegularGroup>
        <span class="lmstooltip">
          <gl-button
            color-primary
            [text]="'groups.add' | translate"
            [routerLink]="['/groups/new']"
            [queryParams]="{ clientId: client.id }"
            title="{{ 'groups.create' | translate }}"
          ></gl-button>
        </span>
      </ng-template>
    </div>
  </lms-toolbar>

  <lms-groups-list
    [listId]="listId"
    [options]="{
      filters: { clientId: client.id }
    }"
  ></lms-groups-list>
</ng-container>

<!-- client without groups -->
<div *ngIf="noGroups">
  <div class="main__void">
    <div class="main__void--icon">
      <span class="glicon-no-class"></span>
    </div>
    <span class="main__void--title">{{ 'groups.noGroups' | translate }}</span>
    <span class="main__void--subtitle">{{ 'groups.noGroupsInfo' | translate }}.</span>
    <gl-button
      color-primary
      [text]="'groups.add' | translate"
      [routerLink]="['/groups/new']"
      [queryParams]="{ clientId: client.id }"
      title="{{ 'groups.create' | translate }}"
    ></gl-button>
  </div>
</div>
